import { render } from "./NavComponent.vue?vue&type=template&id=1c451ea8&scoped=true"
import script from "./NavComponent.vue?vue&type=script&lang=js"
export * from "./NavComponent.vue?vue&type=script&lang=js"

import "./NavComponent.vue?vue&type=style&index=0&id=1c451ea8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c451ea8"]])

export default __exports__